This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="teacherLevelsPage">
    <div class="pageContainer">
      <section>
        <div class="basicBlock">
          <p class="header upper">{{ $t("teacherLevels.ownLevels") }}</p>
          <!-- Create new level -->
          <div class="levels">
            <router-link
              class="level addLevel"
              to="/docent/levelmaker"
              @click="createNewLevel"
            >
              <img
                src="@/assets/images/icons/PlusBlack.svg"
                alt="Add level icon"
              />
            </router-link>
            <div class="level" v-for="l in this.levels" :key="l.levelId">
              <img
                v-if="l.preview.length < 50"
                src="@/assets/images/DefaultLevel.png"
                @click="goToLevel(l)"
              />
              <img
                v-else
                :src="`data:image/png;base64,${l.preview}`"
                @click="goToLevel(l)"
              />
              <p class="levelName">{{ l.name }}</p>
              <div class="medal">
                <div class="tooltip">
                  <button
                    class="button neutral"
                    @click="cloneMylevel(l.levelId)"
                  >
                    <img
                      src="@/assets/images/icons/Duplicate.svg"
                      alt="Duplicate level icon"
                    />
                  </button>
                  <div class="tooltipText top-7">
                    <p>{{ $t("teacherLevels.tooltips.duplicate") }}</p>
                    <i></i>
                  </div>
                </div>
                <div class="tooltip">
                  <button
                    class="button warning"
                    @click="l.errorVisible = 'overlayVisible'"
                  >
                    <img src="@/assets/images/icons/Trash.svg" />
                  </button>
                  <div class="tooltipText top-6">
                    <p>{{ $t("teacherLevels.tooltips.delete") }}</p>
                    <i></i>
                  </div>
                </div>
              </div>
              <div class="overlay" :class="l.errorVisible">
                <div class="message">
                  <div class="messageHeader error">
                    {{ $t("teacherLevels.deleteLevel") }}
                  </div>
                  <p>
                    {{ $t("teacherLevels.deleteWarning") }}
                  </p>
                  <div class="buttonsCenter">
                    <button class="button warning" @click="l.errorVisible = ''">
                      {{ $t("teacherLevels.cancel") }}
                    </button>
                    <button
                      class="button success"
                      @click="deleteMyLevel(l.levelId)"
                    >
                      {{ $t("teacherLevels.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  <QuestionButton :wikiSubjects="this.wikiSubjects" />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import QuestionButton from "@/components/QuestionButton.vue";
import router from "@/router";
import * as wasm from "codeParser";
import { levelInfo } from "@/utils/Types";

import {
  createLevel,
  cloneLevel,
  deleteLevel,
  getMyLevelsTeacher,
} from "@/utils/apiCalls/LevelAPI";
@Options({
  data() {
    return {
      levels: [],
      wikiSubjects: [],
      errorVisible: "",
    };
  },
  mounted() {
    this.updateQuestionButton();
    this.updateLevelsList();
  },
  methods: {
    getImage(l: levelInfo): string {
      return "data:image/png; base64, " + l.preview;
    },

    updateLevelsList() {
      getMyLevelsTeacher().then((response) => {
        if (response !== null) this.levels = response;
      });
    },
    createNewLevel() {
      console.log('create new level!!!');
      this.$store.commit("setLevelMakerNewLevel", true);
      this.$store.state.levelMakerInfo.layout = null;
      this.$store.state.levelMakerInfo.name = "Placeholder";

      createLevel("robbie", "Placeholder").then((response) => {
        console.log('response', response);
        if (response != null) this.goToLevel(response);
      });
    },
    cloneMylevel(id: number) {
      cloneLevel(id).then(() => {
        this.updateLevelsList();
      });
    },
    deleteMyLevel(id: number) {
      console.log('deletelevel', id);
      deleteLevel(id).then(() => {
        this.updateLevelsList();
      });
      this.errorVisible = "";
    },
    goToLevel(level: levelInfo) {
      this.$store.commit("setLevelMaker", level);
      
      if (level.solution && level.solution !== '[]') {
        try {
          // Parse the level.solution JSON string
          let solution = JSON.parse(level.solution);

          // Dynamisch de dropdownVariables en worldVariableNames genereren zoals in loadCode
          let dropdownVariables: { [key: string]: string[] } = {};
          let worldVariableNames: string[] = [];

          // Haal werelddata op
          let worldData = this.$store.getters.getWorldData;

          // Voeg variabelen toe aan dropdownVariables en worldVariableNames
          worldData.variables.forEach((wVar: { type: string; name: string }) => {
            worldVariableNames.push(wVar.name);
            let options: string[] = [];
            worldData.constants.forEach((wCon: { type: string; name: string }) => {
              if (wCon.type === wVar.type) {
                options.push(wCon.name);
              }
            });
            dropdownVariables[wVar.name] = options;
          });

          // Convert solution to PSD using the same parameters as loadCode
          let psdAnswer = wasm.toPsd(
            JSON.stringify(solution),
            this.$store.getters.getIDELanguage,
            JSON.stringify(dropdownVariables),
            JSON.stringify(worldVariableNames)
          );

          console.log("psdAnswer", psdAnswer);
          this.$store.commit("setLevelMakerAnswerHTML", psdAnswer);

        } catch (error) {
          console.log("Could not parse level solution.");
          console.log(error);
        }
      }

      router.push("/docent/levelmaker");
    },
    updateQuestionButton() {
      this.wikiSubjects.push(
        {
          wikiButton: { name: this.$t("wiki.levMaker"), item: "levMakerPage" },
        }
        //here you can add more page references
      );
    },
  },
  components: {
    QuestionButton,
  },
})
export default class TeacherLevels extends Vue {}
</script>

<style lang="scss">
@import "src/assets/stylesheets/pages/TeacherLevels.scss";
@import "src/assets/stylesheets/general/Levels.scss";
</style>
